import { useEffect, useState } from "react";
import { motion } from "framer-motion";

const VERDICT_COLORS = {
  REAL: "#059669",
  FAKE: "#DC2626",
  UNCERTAIN: "#F59E0B",
};

export default function ConfidenceMeter({ confidence, verdict }) {
  const [animatedValue, setAnimatedValue] = useState(0);
  const radius = 68;
  const strokeWidth = 10;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (animatedValue / 100) * circumference;
  const color = VERDICT_COLORS[verdict] || "#F59E0B";

  useEffect(() => {
    const timer = setTimeout(() => setAnimatedValue(confidence), 200);
    return () => clearTimeout(timer);
  }, [confidence]);

  return (
    <div className="flex flex-col items-center gap-3" data-testid="confidence-meter">
      <svg
        width="180"
        height="180"
        viewBox="0 0 180 180"
        aria-label={`Confidence: ${confidence}%`}
      >
        {/* Background track */}
        <circle
          cx="90"
          cy="90"
          r={radius}
          fill="none"
          stroke="currentColor"
          strokeWidth={strokeWidth}
          className="text-muted opacity-20"
        />
        {/* Animated arc */}
        <circle
          cx="90"
          cy="90"
          r={radius}
          fill="none"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap="round"
          transform="rotate(-90 90 90)"
          className="confidence-ring"
        />
        {/* Center value */}
        <text
          x="90"
          y="82"
          textAnchor="middle"
          fontSize="30"
          fontWeight="700"
          fontFamily="Outfit, sans-serif"
          fill={color}
          data-testid="confidence-value"
        >
          {(confidence == null || isNaN(confidence)) ? "—" : `${Math.round(confidence)}%`}
        </text>
        <text
          x="90"
          y="105"
          textAnchor="middle"
          fontSize="9"
          fontFamily="JetBrains Mono, monospace"
          fill="#888"
          letterSpacing="3"
        >
          CONFIDENCE
        </text>
      </svg>
    </div>
  );
}
